<template>
      <el-dialog
            :visible.sync="visible"
            append-to-body
            :show-close="true"
            :center="true"
            :before-close="handleClose"
            title="分类"
        >
        <div>
            <el-container style="height: 500px; border: 1px solid #eee">
                <el-aside width="200px" style="height:500px">
                    <el-menu :default-active="defaultActive"  style="height:500px">
                        <el-menu-item  v-for="(item,index) in classList" 
                            :key="item.value"
                            :index="index+1+''" 
                            @click="selectMenu(index)"
                            >
                            <span slot="title">{{item.label}}</span>
                        </el-menu-item>
                    </el-menu>
                </el-aside>
                <el-container>
                    <el-main class="category">
                        <span v-for=" (item,index) in children"  :key="item.value" @click="selectCategory(item.value)" :class="{'active': item.checked==true}">
                            {{item.label}} 
                        </span>
                      
                    </el-main>
                </el-container>
            </el-container>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submit">确定</el-button>
            <el-button @click="visible = false">取 消</el-button>
        </span>
     </el-dialog>   
</template>


<script>
import { getClassTree} from "@/api/director/job/index.js";

export default {
    data() {
        
        return {
            visible: false,
            defaultActive:'1',
            classList:[],
            children:[],
            classId:"",
            class:null,
        }
           
    },


    methods: {
        handleClose() {
            this.visible = false;
        },


        init() {
            this.visible = true;
            this.initClassList();
        },


        //
        initClassList(){
            var that = this;
            getClassTree({}).then((response) => {
                console.log(response)
                that.classList = response.data;
                that.children=that.classList[0].children;
            });
        },

        selectMenu(index){
            var that = this;
            that.children=that.classList[index].children;
            
        },

        submit(){
            if(this.classId==''){
                this.$message.warning("请选择类别");
                return;
            }else{
                this.$emit('setClassId',this.class);
                this.visible = false;
            }
        },

        selectCategory(index){
            var that=this;
            for (let item of that.children) {

                if(item.value ==index){
                    item.checked=true;
                    that.classId=item.value;
                    that.class=item;
                }else{
                    item.checked=false;
                }
           }
            that.$forceUpdate();
        }
       
       
    }
}
</script>
<style lang="scss" scoped>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }

  .category{
    flex-flow: wrap;
    height: 500px;
    span{
        padding: 10px;
    margin: 5px;
    line-height: 40px;
    word-wrap: break-all;
    word-break: normal;
    cursor: pointer;

        &.active{
            background: #4c71db;
            color: #ffffff;
        }
    }
  }
</style>
